"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SchoolInfoByUrnDoesNotExistError extends client_library_1.ExtendableError {
    constructor(urn) {
        super(`School info does not exist for URN: ${urn}`);
        this.urn = urn;
    }
}
exports.default = SchoolInfoByUrnDoesNotExistError;
//# sourceMappingURL=SchoolInfoByUrnDoesNotExistError.js.map